import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

export default function PropertyCard({ p }) {
  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(
          <span key={i} style={{ color: '#FFD700', fontSize: '10px' }}>
            ★
          </span>
        );
      } else if (rating > i - 1 && rating < i) {
        stars.push(
          <span key={i} style={{ color: '#FFD700', fontSize: '10px' }}>
            ★
          </span>
        );
      } else {
        stars.push(
          <span key={i} style={{ color: '#E0E0E0', fontSize: '10px' }}>
            ★
          </span>
        );
      }
    }
    return stars;
  };

  const minPrice = useMemo(() => {
    if (!p?.roomsPrice) return null;

    const prices = Object.values(p.roomsPrice)
      .map(Number)
      .filter(v => v > 0);

    return prices.length ? Math.min(...prices) : null;
  }, [p]);


  return (
    <article
      style={{
        margin: '8px 10px',
        height: '140px',
        borderRadius: '12px',
        position: 'relative',
        overflow: 'hidden',
        cursor: 'pointer',
        background: 'transparent',
        border: '1px solid rgba(221, 65, 36, 0.3)',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
      }}
      onClick={() => window.location.href = `/property/${p._id}`}
    >
      {/* Continutul principal */}
      <div
        style={{
          display: 'flex',
          height: '100%',
          padding: '10px',
          gap: '10px',
        }}
      >
        {/* Partea stanga - Text si informatii */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
          }}
        >
          {/* Sectiunea superioara: titlu, locatie, descriere */}
          <div style={{ flex: 1, minHeight: 0 }}>
            {/* Numele proprietatii */}
            {/* Numele proprietatii */}
            <h3
              style={{
                margin: '0 0 2px 0',
                fontFamily: "'Sora', sans-serif",
                fontSize: '15px',
                fontWeight: 'bold',
                color: '#0A3E5A',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                lineHeight: '1.1',
              }}
            >
              {p.title}
            </h3>

            {/* Rand categorie + locatie */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                fontSize: '10px',
                marginBottom: '6px',
                gap: '6px',
                flexWrap: 'wrap',
                fontFamily: "'Sora', sans-serif",
              }}
            >
              {/* CATEGORIE */}
              {p.propertyType && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#006d77' }}>
                  <span>{p.propertyType}</span>

                  {p.classification != null && p.classification > 0 && (
                    <span>
                      {p.propertyType === 'Pensiune'
                        ? '🏵'.repeat(p.classification)
                        : p.propertyType === 'Hotel'
                          ? '★'.repeat(p.classification)
                          : ''}
                    </span>
                  )}
                </div>
              )}

              {/* PIN + LOCATIE */}
              <div style={{ display: 'flex', alignItems: 'center', color: '#666' }}>
                <span style={{ color: '#DD4124', fontSize: '9px' }}>📍</span>
                <span style={{ marginLeft: '3px', whiteSpace: 'nowrap' }}>
                  {p.locality && p.county
                    ? `${p.locality}, ${p.county}`
                    : 'Adresa indisponibila'}
                </span>
              </div>
            </div>

            {/* Descriere */}
            <div
              style={{
                fontSize: '10px',
                color: '#333333',
                lineHeight: '1.2',
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                height: '36px',
                marginBottom: '4px',
              }}
            >
              {p.description || 'Fara descriere'}
            </div>
          </div>

          {/* Randul de jos: rating, pret, statistici */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '36px',
              paddingTop: '0px',
              marginBottom: '8px',
              borderTop: '1px solid rgba(0, 0, 0, 0.05)',
            }}
          >

            {/* Rating - Coloana 1 */}
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
              <div style={{ display: 'flex', gap: '1px', marginBottom: '1px' }}>
                {renderStars(p.averageRating || 0)}
              </div>
              <div
                style={{
                  fontSize: '9px',
                  fontWeight: 'bold',
                  color: '#0A3E5A',
                  whiteSpace: 'nowrap',
                }}
              >
              </div>
            </div>

            {/* Pret - Coloana 2 */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
              }}
            >
              <span
                style={{
                  fontSize: '11px',
                  fontWeight: '600',
                  fontFamily: "'Sora', sans-serif",
                  color: '#0A3E5A',
                  whiteSpace: 'nowrap',
                }}
              >
                {minPrice ? `de la ${minPrice} RON / Noapte` : 'Pret indisponibil'}
              </span>
              {p.discount > 0 && (
                <span
                  style={{
                    fontSize: '11px',
                    fontWeight: '600',
                    color: '#DD4124',
                    marginLeft: '4px',
                  }}
                >
                  -{p.discount}%
                </span>
              )}
            </div>

            {/* Statistici - Coloana 3 */}
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
              <div style={{ display: 'flex', gap: '6px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ fontSize: '9px', color: '#0A3E5A' }}>👁️</span>
                  <span
                    style={{
                      fontSize: '9px',
                      fontWeight: 500,
                      color: '#0A3E5A',
                      marginLeft: '2px',
                    }}
                  >
                    {p.totalBookings || 0}
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ fontSize: '9px', color: '#DD4124' }}>💬</span>
                  <span
                    style={{
                      fontSize: '9px',
                      fontWeight: 500,
                      color: '#DD4124',
                      marginLeft: '2px',
                    }}
                  >
                    {p.comments || 0}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Partea dreapta - Imagine */}
        <div
          style={{
            width: '96px',
            height: '90px',
            borderRadius: '6px',
            overflow: 'hidden',
            backgroundColor: 'transparent',
            flexShrink: 0,
          }}
        >
          {p.images?.[0] ? (
            <img
              src={p.images[0]}
              alt={p.title}
              style={{
                width: '96px',
                height: '90px',
                objectFit: 'cover',
                display: 'block',
              }}
              onError={(e) => {
                e.target.src = 'https://via.placeholder.com/96x90';
              }}
            />
          ) : null}
        </div>

      </div>

      {/* Link-ul pentru accesibilitate */}
      <Link
        to={`/property/${p._id}`}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0,
          zIndex: 1,
        }}
        aria-label={`Viziteaza ${p.title}`}
      />
    </article >
  );
}